import { cn } from '@tripleten/cn';

export const cnSpinner = cn('spinner');
